<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits, ref, defineExpose } from 'vue';

/*==================================================================*/
/*================= COMPONENTS IMPORTS =============================*/
/*==================================================================*/

import Navegacao from '@/components/v2/modais/ModalFullscreen/Navegacao/Navegacao.vue';
import ModalFullscreenBase from '@/components/v2/base/ModalFullscreenBase/ModalFullscreenBase.vue';

/*==================================================================*/
/*================== EMITS =========================================*/
/*==================================================================*/

const emit = defineEmits(['onOpen', 'onClose']);

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false
    },
    dado: {
        type: Object,
        default: () => ({})
    }
});

/*==================================================================*/
/*================== MODAL BASE REF ================================*/
/*==================================================================*/

const modalFullscreenBaseRef = ref();

/*==================================================================*/
/*================== ABRIR MODAL ===================================*/
/*==================================================================*/

const abrirModal = async () => {

    await modalFullscreenBaseRef.value?.abrirModal();
    emit('onOpen');

};

/*==================================================================*/
/*================== FECHAR MODAL ==================================*/
/*==================================================================*/

const fecharModal = async () => {

    await modalFullscreenBaseRef.value?.fecharModal();
    emit('onClose');

};

/*==================================================================*/
/*================== EXPOSE ========================================*/
/*==================================================================*/

defineExpose({ abrirModal, fecharModal });

</script>

<template>

    <ModalFullscreenBase ref="modalFullscreenBaseRef">

        <Navegacao
            :dado="props.dado"
            :disabled="props.disabled"
            @fecharModal="fecharModal"
        >

            <template #navegacao-titulo>

                <slot name="modal-navegacao-titulo"></slot>

            </template>
    
            <template #navegacao-botoes>

                <slot name="modal-navegacao-botoes"></slot>

            </template>

        </Navegacao>

        <slot name="modal-conteudo"></slot>

    </ModalFullscreenBase>

</template>

<style scoped>
</style>
